module.exports = " <div class=vux-flexbox-item :style=style> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/flexbox/flexbox-item.vue
// module id = 222
// module chunks = 2